import './globals'

// Node Modules
import 'bootstrap/js/dist/util'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/modal'
import 'bootstrap-select'
import 'jquery-match-height'
import 'slick-carousel/slick/slick'
import '@cmyee/pushy/js/pushy.min.js'
import 'isotope-layout'
import 'imagesloaded'


// Vendor
// import './vendor/parsley/parsley.min.js';
// import './vendor/parsley/parsley-i18n/de.js';
// import './vendor/pushy.min.js';
import './vendor/jquery.fancybox'

// Template
import 'globals'
import './main/base'
import './main/accordion'
import './main/slider'
import './main/tabs'
import './main/filter'
import './main/ga.tracking'
import './main/history'
import './main/softgarden'
import './main/fancybox'
import './main/masonry'
